import React, { useState } from 'react';
import { Modal } from 'tea-component';
import { connect, useIntl } from 'umi';
import { PromptListType } from '../types';
import SvgIcon from '@home/components/SvgIcon';
import PromptForm, { PromptFormPropsType } from './PromptForm';
import './index.scss';
import { getDefaultPromptList } from '../PromptList';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import BubbleCommon, {
  aigcGptModalTypeTips,
} from '@op/components/BubbleCommon';

export type GPTPromptType = {
  visible: boolean;
  close: () => void;
  studioGameInfo?: any;
  studioWholeGameInfo?: any;
  promptList?: PromptListType | ((wholeGameInfo: any) => PromptListType);
  needRequestPrompt?: boolean;
  saveName?: string;
  userInfo: any;
} & Omit<PromptFormPropsType, 'promptList'>;

/**
 * 选择GPT相关配置的浮窗
 * @returns
 */
function PromptModal({
  close,
  visible,
  wholeGameInfo: propsWholeGameInfo,
  gameInfo: propsGameInfo,
  studioGameInfo,
  studioWholeGameInfo,
  promptList,
  needRequestPrompt = true,
  ...props
}: GPTPromptType) {
  const { formatMessage } = useIntl();
  const wholeGameInfo = studioWholeGameInfo || propsWholeGameInfo;
  const gameInfo = studioGameInfo || propsGameInfo;

  useRequestFontWebConfig({
    keys: [{ key: 'ai_prompt_list' }],
    gameInfo,
    needRequest: needRequestPrompt,
  });

  const [historyVisible, setHistoryVisible] = useState(false);
  const toggleHistoricalPrompt = () => {
    setHistoryVisible(!historyVisible);
  };

  function getModalCaption() {
    if (!historyVisible)
      return (
        <BubbleCommon tipsMap={aigcGptModalTypeTips} placement="top">
          {formatMessage({ id: 'AI Settings' })}
        </BubbleCommon>
      );
    return (
      <div className="dbo-historical-modal-title">
        <div
          className="dbo-historical-modal-goback"
          onClick={toggleHistoricalPrompt}
        >
          <SvgIcon type="left-pointing" className="dbo-historical-modal-icon" />
          {formatMessage({ id: 'Historical prompt' })}
        </div>
        <div className="dbo-historical-modal-cilck">
          {formatMessage({ id: 'Click to apply' })}
        </div>
      </div>
    );
  }

  if (!visible) return null;

  const newPromptList =
    promptList || ((gameInfo: any) => getDefaultPromptList(gameInfo));
  const realPromptList =
    typeof newPromptList === 'function'
      ? newPromptList(wholeGameInfo)
      : newPromptList;

  return (
    <Modal
      visible={visible}
      caption={getModalCaption()}
      onClose={close}
      size={920}
      destroyOnClose
      className={
        historyVisible ? 'dbo-historical-modal' : 'dbo-aigc-modal-wrapper'
      }
    >
      <PromptForm
        handleCancel={() => close()}
        promptList={realPromptList}
        wholeGameInfo={wholeGameInfo}
        historyVisible={historyVisible}
        toggleHistoricalPrompt={toggleHistoricalPrompt}
        gameInfo={gameInfo}
        isModal
        {...props}
      ></PromptForm>
    </Modal>
  );
}

export default connect((state: any) => {
  const { opinionCommon, home } = state;
  return {
    wholeGameInfo: opinionCommon.wholeGameInfo,
    gameInfo: opinionCommon.gameInfo,
    userInfo: home.userInfo,
  };
})(PromptModal);
